/**
 * Student/staff portal detection and routes that must not use admin RBAC (module "show" permissions).
 */

export function isStudentUser(user: Record<string, any> | null | undefined): boolean {
  if (!user) return false;
  const typeCandidate = (
    user.type ||
    user.user_type ||
    user.role?.name ||
    user.role?.slug ||
    ""
  )
    .toString()
    .toLowerCase();

  if (typeCandidate.includes("student")) {
    return true;
  }

  if (
    user.student_id ||
    user.student ||
    (Array.isArray(user.roles) &&
      user.roles.some((role: any) =>
        String(role?.name || role?.slug || "")
          .toLowerCase()
          .includes("student")
      ))
  ) {
    return true;
  }

  return false;
}

export function isStaffUser(user: Record<string, any> | null | undefined): boolean {
  if (!user) return false;

  if (user.staff_id || user.staffProfile) {
    return true;
  }

  const typeCandidate = (
    user.type ||
    user.user_type ||
    user.role?.name ||
    user.role?.slug ||
    ""
  )
    .toString()
    .toLowerCase();

  if (typeCandidate.includes("staff") || typeCandidate.includes("academic")) {
    return true;
  }

  if (Array.isArray(user.roles)) {
    return user.roles.some((role: any) => {
      const n = String(role?.name || role?.slug || "").toLowerCase();
      return n.includes("staff") || n.includes("academic");
    });
  }

  return false;
}

/** Student self-service URLs (not admin `/student` list). */
export function isStudentSelfServicePath(rawPath: string): boolean {
  const path = (rawPath.split("?")[0] || "").trim();
  if (path === "/student") return false;

  const topLevel = [
    "/student-dashboard",
    "/student-schedule",
    "/student-grades",
    "/student-profile",
    "/student-section-selection",
  ];
  if (topLevel.includes(path)) return true;

  if (path.startsWith("/student/")) return true;

  return false;
}

/** Staff portal URLs (not admin `/staff` CRUD). */
export function isStaffSelfServicePath(rawPath: string): boolean {
  const path = (rawPath.split("?")[0] || "").trim();
  if (path === "/staff") return false;
  if (path.startsWith("/staff-")) return true;
  if (path.startsWith("/staff/")) return true;
  return false;
}
